import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Q88Component } from '../q88/q88.component';





import { MatPaginatorModule } from '@angular/material/paginator';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { ChartModule } from 'angular-highcharts';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { Q88RoutingModule } from './q88-routing.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';



@NgModule({
  declarations: [
    Q88Component
  ],
  imports: [
    CommonModule,
    MatPaginatorModule,
    MaterialModule,
    ExpansionPanelModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    CustomDatePickerModule,
    CustomInputModule,
    ExpansionPanelModule,
    ChartModule,
    MatDialogModule,
    PcMultiSelectFilterModule,
    Q88RoutingModule
  ],
  exports: [
    Q88Component
  ]
})
export class Q88Module { }
